import LedgerReportsActionTypes from './LedgerReports.types';

/** ***************** GET LEDGER REPORTS START *********************** */
export const getLedgerReportsDetailsStart = (getData: any) => ({
	type: LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_START,
	payload: getData,
});

export const getLedgerReportsDetailsSuccess = (successData: any) => ({
	type: LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_SUCCESS,
	payload: successData,
});

export const getLedgerReportsDetailsFailure = (failureData: any) => ({
	type: LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_FAILURE,
	payload: failureData,
});

export const getLedgerReportsDetailsResponseResetStart = () => ({
	type: LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_RESPONSE_RESET,
});

export const getLedgerReportsDetailsResponseChanged = () => ({
	type: LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET LEDGER REPORTS END *********************** */

/** ***************** GET ACCOUNT HEAD START *********************** */
export const getAccountHeadStart = (getData: any) => ({
	type: LedgerReportsActionTypes.GET_ACCOUNT_HEAD_START,
	payload: getData,
});

export const getAccountHeadSuccess = (successData: any) => ({
	type: LedgerReportsActionTypes.GET_ACCOUNT_HEAD_SUCCESS,
	payload: successData,
});

export const getAccountHeadFailure = (failureData: any) => ({
	type: LedgerReportsActionTypes.GET_ACCOUNT_HEAD_FAILURE,
	payload: failureData,
});

export const getAccountHeadResponseResetStart = () => ({
	type: LedgerReportsActionTypes.GET_ACCOUNT_HEAD_RESPONSE_RESET,
});

export const getAccountHeadResponseChanged = () => ({
	type: LedgerReportsActionTypes.GET_ACCOUNT_HEAD_RESPONSE_CHANGED,
});
/** ***************** GET ACCOUNT HEAD END *********************** */
